export default __webpack_public_path__ + "static/media/activity-improve-shade.b75270e7.svg";